import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	PetitionDetailsAiSummaries,
	type PetitionDetailsAiSummariesQuery,
	type PetitionDetailsAiSummariesQueryVariables,
} from './aiSummaries.graphql';

export type AiSummaries = NonNullable<NonNullable<PetitionDetailsAiSummariesQuery['petition']>['aiSummaries']>;

export async function getAiSummaries(
	{ gql: { fetch } }: UtilityContext,
	{ slugOrId }: { slugOrId: string },
): Promise<AiSummaries | null> {
	const { data } = await fetch<PetitionDetailsAiSummariesQuery, PetitionDetailsAiSummariesQueryVariables>({
		query: PetitionDetailsAiSummaries,
		variables: { slugOrId },
		rejectOnError: true,
	});
	return data.petition?.aiSummaries ?? null;
}
